import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import legalEntityIndividualReadAction from './legalEntityIndividualRead.action.json'

const legalEntityIndividualReadDefinition = defineReadAutoAction(
  legalEntityIndividualReadAction,
  'legalEntityIndividual',
)

export default legalEntityIndividualReadDefinition
